import { FolderRenderParams } from '@lessonup/typescript-core/domain';
import { ImageUtils } from '@lessonup/typescript-core/utils';
import React from 'react';
import FolderCounts from './FolderCount';

interface Props {
  folder: FolderRenderParams;
}
const FolderVisual: React.FC<Props> = ({ folder }) => {
  const divStyle = folder.image
    ? {
        backgroundImage: 'url(' + ImageUtils.checkImageUrl(folder.image) + ')',
      }
    : {};

  return (
    <div className="visual" style={divStyle}>
      <div className="hover-el"></div>
      <FolderCounts count={folder.counts} />
    </div>
  );
};
export default FolderVisual;
